export class BeanStatus{

  statIdCdStatus: number | null;
  statDsStatus: string | null;
  statInConfiguracao: string | null;
  statDhInativo: string | null;
  statDhRegistro: string | null;
}
